import Vue from 'vue';
import axios from 'axios';
import constants from 'src/common/constants';

axios.defaults.baseURL = 'https://api.fabrikkan.is/_/moya/pilot/api';
axios.defaults.timeout = 60000;
axios.defaults.headers.common['Accept-Version'] = 2;
axios.defaults.headers.common['X-Access-Token'] = constants.DEFAULT_ACCESS_TOKEN;

if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = 'http://fabrikkan.th/_/moya/pilot/api';
}

Vue.prototype.$axios = axios;
